import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import { pendingApprovalsActions as actions } from './pendingApprovalsSlice';

// Same per-resource GET shape ReviewApproval/slice/saga.ts's workers use
// (`call(request, url)` -> `put(success)`, `catch` -> `put(failure)` with
// only serializable error info) - same `/api/v2/approvals/...` family, no
// bespoke fetch/error-handling logic introduced here.
const API_V2_URL = process.env.REACT_APP_API_V2_URL;

export function* loadPendingApprovalsCount() {
  try {
    const response = yield call(
      request,
      `${API_V2_URL}/approvals/pending-count`
    );
    yield put(actions.pendingApprovalsCountLoaded(response));
  } catch (e: any) {
    yield put(
      actions.loadPendingApprovalsCountError({
        status: e?.response?.status || 'unknown',
        statusText: e?.response?.statusText || 'Network Error',
        message:
          e?.message || 'An error occurred while loading pending approvals'
      })
    );
  }
}

export function* pendingApprovalsSaga() {
  yield takeLatest(
    actions.loadPendingApprovalsCount.type,
    loadPendingApprovalsCount
  );
}
